<template>
  <div class="gradient-bg min-h-screen flex flex-col items-center justify-center p-4 relative">
    <div class="flex flex-col items-center max-w-[500px]">
      <div class="text-center mb-[20px] logo-animation">
        <img src="/new-logo.png" alt="Medisyn Logo" class="logo-img"/>
      </div>

      <div class="w-[380px] bg-white shadow-2xl rounded-2xl card-animation">
        <div class="text-center pt-6 pb-4 px-8">
          <h1 class="text-2xl font-bold text-gray-900 mb-2">找回密码</h1>
          <p class="text-gray-500 text-sm">通过手机号验证重置登录密码</p>
        </div>

        <div class="px-8 pb-6">
          <form @submit.prevent="handleReset" class="w-full space-y-4">
            <!-- 手机号 -->
            <div class="space-y-2">
              <label class="text-sm font-medium text-gray-700 block">手机号</label>
              <input v-model="phone" type="tel" placeholder="请输入注册手机号" class="input-field" />
            </div>

            <!-- 图形验证码 -->
            <div class="space-y-2">
              <label class="text-sm font-medium text-gray-700 block">图形验证码</label>
              <div class="flex items-center space-x-2">
                <input v-model="captcha" type="text" placeholder="请输入图形验证码" class="captcha-input" />
                <img :src="captchaImg" alt="验证码" @click="getCaptcha" style="cursor:pointer;" title="点击刷新验证码" class="captcha-img" />
              </div>
            </div>

            <!-- 短信验证码 -->
            <div class="space-y-2">
              <label class="text-sm font-medium text-gray-700 block">短信验证码</label>
              <div class="flex items-center space-x-2">
                <input v-model="smsCode" type="text" placeholder="请输入短信验证码" class="captcha-input" />
                <button type="button" class="btn-secondary min-w-[110px]" :disabled="sendCountdown>0 || sending" @click="handleSendSms">
                  {{ sendCountdown>0 ? sendCountdown+'s 后重试' : (sending ? '发送中...' : '获取验证码') }}
                </button>
              </div>
            </div>

            <!-- 新密码 -->
            <div class="space-y-2">
              <label class="text-sm font-medium text-gray-700 block">新密码</label>
              <input v-model="newPassword" :type="showPassword ? 'text' : 'password'" placeholder="请输入新密码" class="input-field pr-10" />
            </div>

            <!-- 确认新密码 -->
            <div class="space-y-2">
              <label class="text-sm font-medium text-gray-700 block">确认新密码</label>
              <input v-model="confirmPassword" :type="showPassword ? 'text' : 'password'" placeholder="请再次输入新密码" class="input-field pr-10" />
            </div>

            <div class="flex items-center justify-between pt-2">
              <router-link :to="{ name: 'Login' }" class="link-text">返回登录</router-link>
              <button type="submit" class="btn-reset" :disabled="submitting">
                {{ submitting ? '提交中...' : '重置密码' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="text-center mt-8">
      <p class="text-white/60 text-xs">© 2024 琼海智医科技有限公司 版权所有</p>
      <p class="text-white/50 text-xs mt-1">岚医全域医疗智能体 · Medisyn Ubimed Agent</p>
    </div>
  </div>
  </template>
<script>
import { sendSmsCode } from '@/services/user/index.js';
export default {
  data() {
    return {
      phone: '',
      captchaImg: '',
      captcha: '',
      checkKey: '',
      smsCode: '',
      newPassword: '',
      confirmPassword: '',
      sending: false,
      sendCountdown: 0,
      countdownTimer: null,
      submitting: false,
      showPassword: false
    }
  },
  mounted() {
    this.getCaptcha();
  },
  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  },
  methods: {
    getCaptcha() {
      this.checkKey = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      fetch(this.$urlbase + '/sys/randomImage/' + this.checkKey)
        .then(res => res.json())
        .then(data => {
          if (data.success && data.result) {
            this.captchaImg = data.result;
          }
        });
    },
    startCountdown(seconds = 60) {
      this.sendCountdown = seconds;
      this.countdownTimer = setInterval(() => {
        if (this.sendCountdown > 0) {
          this.sendCountdown -= 1;
        } else {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },
    async handleSendSms() {
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      if (!this.captcha || !this.checkKey) {
        this.$message.warning('请先输入图形验证码');
        return;
      }
      this.sending = true;
      try {
        const resp = await sendSmsCode({ mobile: this.phone, smsmode: 2 });
        if (resp && resp.code === 200) {
          this.$message.success('验证码已发送');
          this.startCountdown(60);
        } else {
          this.$message.error(resp.message || '验证码发送失败');
          this.getCaptcha(); // 失败重刷验证码
        }
      } catch (e) {
        this.$message.error('发送失败，请稍后重试');
        this.getCaptcha();
      } finally {
        this.sending = false;
      }
    },
    async handleReset() {
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      if (!this.smsCode) {
        this.$message.warning('请输入短信验证码');
        return;
      }
      if (!this.newPassword || this.newPassword.length < 6) {
        this.$message.warning('新密码至少6位');
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$message.warning('两次输入的新密码不一致');
        return;
      }
      this.submitting = true;
      try {
        // 这里预留后端接口对接：例如 /sys/user/resetPassword
        // const resp = await request({ url: '/sys/user/resetPassword', method: 'POST', data: { phone: this.phone, smsCode: this.smsCode, newPassword: this.newPassword } });
        // if (resp && resp.success) { ... }
        this.$message.success('重置成功（演示），请使用新密码登录');
        this.$router.push({ name: 'Login' });
      } catch (e) {
        this.$message.error('重置失败，请稍后重试');
      } finally {
        this.submitting = false;
      }
    }
  }
}
</script>
<style lang="less" scoped>
//@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css");
</style>
<style src="@/assets/style/pages/login.css"></style>


